export default __webpack_public_path__ + "static/media/eye-closed.inline.fbbd5fdf.svg";